<div class="app-layout" [class.sidebar-collapsed]="sidebarCollapsed" [class.mobile-open]="mobileMenuOpen">

  <!-- Sidebar -->
  <app-sidebar
    [collapsed]="sidebarCollapsed"
    [mobileOpen]="mobileMenuOpen"
    (toggle)="onSidebarToggle()"
    (mobileClose)="mobileMenuOpen = false"
  ></app-sidebar>

  <!-- Mobile overlay -->
  <div class="mobile-overlay" *ngIf="mobileMenuOpen" (click)="mobileMenuOpen = false"></div>

  <!-- Main content wrapper -->
  <div class="main-wrapper">
    <app-header (menuToggle)="onHeaderMenuToggle()"></app-header>

    <main class="content-area" #contentArea>
      <!--
        #outlet gives us the outlet reference.
        The wrapping div carries [@routeSlide] so Angular can animate
        the outgoing and incoming views as sibling absolute elements.
      -->
      <div class="route-wrap" [@routeSlide]="routeState">
        <router-outlet #outlet="outlet" (activate)="onRouteActivate(outlet)"></router-outlet>
      </div>
    </main>

    <app-footer></app-footer>
  </div>
</div>

<!-- Global, read-only Approval Request Details dialog — opened from a notification click
     on any page without navigating. -->
<app-request-detail-dialog></app-request-detail-dialog>
